.wrapper {
  position: relative;
  border: 1px solid var(--tractie-color-border-default);
  border-radius: 4px;
  margin-bottom: 1rem;
}

.bodyWithLegend {
  display: flex;
  align-items: stretch;
  position: relative;
}

.chartArea {
  position: relative;
  flex: 1;
  min-width: 0;
  z-index: 2;
}

.legendColumn {
  display: flex;
  flex-direction: column;
  background-color: var(--tractie-color-background-default);
  z-index: 2;
  position: relative;
  justify-content: end;
}

.legendTopSpacer {
  flex: 0 0 52px;
}

.legendItem {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 8px;
  cursor: pointer;
  position: relative;
  z-index: 2;
  height: 100%;
}

.legendItem[data-selected] {
  background-color: var(--tractie-color-background-selected-default);
}

.legendText {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.legendNummerRow {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.legendNummer {
  font-size: 18px;
  font-weight: 700;
  color: var(--tractie-color-content-emphasis);
}

.legendIngeregeldIcon {
  flex-shrink: 0;
}

.legendSubtype {
  font-size: 14px;
  color: var(--tractie-color-content-subtle);
}

.miniMwdScrollContainerStyle {
  position: relative;
  display: flex;
  min-height: 100%;
  background-color: var(--tractie-color-background-default);
  height: auto;
  overflow: auto hidden;
  scrollbar-color: initial;
  user-select: none;
}

.svgContainer {
  width: auto;
}

.miniMwdScrollContainerStyle::-webkit-scrollbar {
  width: 64px;
  height: 12px;
  background: #eee;
  border-top: 1px solid #ccc;
}

.miniMwdScrollContainerStyle::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 8px;
  width: 64px;
  height: 12px;
}

.miniMwdScrollContainerStyle::-webkit-scrollbar-thumb:active {
  background: #555;
}
